import React from 'react';
import t from '~t';
import {
  Modal,
  ModalHeader as Header,
  ModalContent as Content,
  Button,
  Layout,
} from '~ui';
import Field from '~co/tags/field';

export default function PicketTagsModal({
  onSubmit,
  onClose,
  ...etc
}) {
  const handleSubmit = (e) => {
    e.preventDefault();
    e.stopPropagation();
    onSubmit && onSubmit();
  };

  return (
    <Modal as='form' onSubmit={handleSubmit} onClose={onClose}>
      <Header title={t.s('addTags')} data-no-shadow>
        <Button type='submit' disabled={!etc.value.length}>
          {etc.value.length
            ? `${t.s('add')} ${etc.value.length} ${t.s('tags').toLowerCase()}`
            : t.s('addTags')}
        </Button>
      </Header>

      <Content>
        <Layout>
          <div className='w-[400px] min-h-[200px]'>
            <Field autoFocus={true} placeholder='' {...etc} />
          </div>
        </Layout>
      </Content>
    </Modal>
  );
}
